import React from "react";
import { CamptheadData } from "../../utils/Data";
import CampaignList from "./CampaignList";
import ManuvalListCamp from "./ManuvalListCamp";
import AgentCampDetailReport from "./AgentCampDetailReport";

const AgentCampReport = () => {
  return (
    <div>
      <h1 className="font-bold text-lg pb-4">Campaign List</h1>

      <div className="bg-white p-4 h-screen">
        <CampaignList
          theadData={CamptheadData}
          user_type="agent"
          camp_search={true}
        />
      </div>
    </div>
  );
};

export default AgentCampReport;
